// Landing page variants for Google Ads scaling
// Each variant has a unique slug (URL path) and custom title parts.
//
// titleParts drives the ON-PAGE H1 (Step0). It does NOT touch the browser tab
// title: that is one site-wide string in public/index.html, identical on every
// domain and route. Don't reintroduce a per-variant pageTitle.

export const LANDING_VARIANTS = {
  'design-your-ai-companion': {
    slug: 'design-your-ai-companion',
    titleParts: { action: 'Design', middle: 'Your AI', object: 'Companion' },
  },
  'build-your-dream-partner': {
    slug: 'build-your-dream-partner',
    titleParts: { action: 'Build', middle: 'Your Dream', object: 'Partner' },
  },
  'chat-with-your-ai-match': {
    slug: 'chat-with-your-ai-match',
    titleParts: { action: 'Chat With', middle: 'Your AI', object: 'Match' },
  },
  'meet-your-ai-companion': {
    slug: 'meet-your-ai-companion',
    titleParts: { action: 'Meet', middle: 'Your AI', object: 'Companion' },
  },
  'create-your-ai-girlfriend': {
    slug: 'create-your-ai-girlfriend',
    titleParts: { action: 'Create', middle: 'Your AI', object: 'Girlfriend' },
  },
  'meet-your-ai-partner': {
    slug: 'meet-your-ai-partner',
    titleParts: { action: 'Meet', middle: 'Your AI', object: 'Partner' },
  },
};

export const VARIANT_SLUGS = Object.keys(LANDING_VARIANTS);

export function getVariantBySlug(slug) {
  return LANDING_VARIANTS[slug] || null;
}
